<template>
  <div>
    <b-dropdown id="dropdown" right class="btn-mobile dropdown-template">
      <template #button-content>
        <div class="d-inline-flex mr-2">
          <font-awesome-icon icon="plus" class="d-md-none" />
          <span class="d-none d-md-block">
            <font-awesome-icon icon="plus-square" class="pointer" />
            <span class="btn-text ml-2">Create New</span>
          </span>
        </div>
      </template>
      <template v-for="(template, i) in templateList">
        <b-dropdown-item @click="selecteTemplate(template.id)">
          <b-button variant="mobile">
            {{ template.name }}
          </b-button>
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  name: "BookingTemplateCreate",
  components: {},
  props: {
    isRedirect: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      templateList: [],
    };
  },
  async created() {
    await this.getTemplateList();
  },
  watch: {},
  methods: {
    selecteTemplate(id) {
      if (this.isRedirect) {
        this.$router.push(`/booking/details/${id}/0`);
      } else {
        this.$emit("addBooking", id);
      }
    },
    async getTemplateList() {
      const res = await this.axios(`/booking/getbookingnameforcreate`);
      this.templateList = res.data.detail;
    },
  },
};
</script>
<style lang="scss">
.dropdown-template {
  .dropdown-menu {
    overflow-y: auto;
    margin-top: 8px;
  }

  .dropdown-item {
    padding: 0;
  }

  .btn .dropdown-toggle {
    display: flex;
  }
}
</style>
